import React, { useState, useEffect, useRef } from 'react';
import { formatOutlineRange } from './outline';

// Render a single inline outline header; onScrollToVerse passed from component
export function renderOutlineHeader(ol, key, onScrollToVerse) {
  const range = formatOutlineRange(ol);
  return (
    <div
      key={key}
      className={`bible-inline-outline bible-inline-outline-lv${ol.level}`}
      style={{ cursor: ol.start_verse ? 'pointer' : 'default' }}
      onClick={ol.start_verse ? () => onScrollToVerse(ol.start_verse) : undefined}
    >
      <div className="bible-inline-outline-title">
        {ol.prefix && <span>{ol.prefix} </span>}{ol.title}
      </div>
      {range && <div className="bible-inline-outline-range">{range}</div>}
    </div>
  );
}

export function OutlineNode({ node, expandAllTrigger, collapseAllTrigger, onNavigate }) {
  const [expanded, setExpanded] = useState(node.level === 1);
  const prevExpand   = useRef(expandAllTrigger);
  const prevCollapse = useRef(collapseAllTrigger);

  useEffect(() => {
    if (expandAllTrigger !== prevExpand.current) {
      prevExpand.current = expandAllTrigger;
      setExpanded(true);
    }
  }, [expandAllTrigger]);

  useEffect(() => {
    if (collapseAllTrigger !== prevCollapse.current) {
      prevCollapse.current = collapseAllTrigger;
      setExpanded(false);
    }
  }, [collapseAllTrigger]);

  const hasChildren = node.children && node.children.length > 0;
  const range = formatOutlineRange(node);
  const clickable = !!node.start_chapter;

  return (
    <div className={`outline-level-${node.level}`} style={{ paddingLeft: node.level === 1 ? 0 : (node.level - 1) * 14 + 'px' }}>
      <div className="outline-item-row">
        <button className="outline-toggle" onClick={() => setExpanded(e => !e)}>
          {hasChildren ? (expanded ? '−' : '+') : <span style={{ opacity: 0 }}>·</span>}
        </button>
        <div
          className={`outline-item-content${clickable ? ' outline-clickable' : ''}`}
          onClick={clickable ? () => onNavigate(node) : undefined}
        >
          {node.prefix && <span className="outline-prefix">{node.prefix} </span>}
          {node.title}
          {range && <span className="outline-range">{range}</span>}
        </div>
      </div>
      {hasChildren && expanded && (
        <div>
          {node.children.map((child, i) => (
            <OutlineNode key={child.id || i} node={child} expandAllTrigger={expandAllTrigger} collapseAllTrigger={collapseAllTrigger} onNavigate={onNavigate} />
          ))}
        </div>
      )}
    </div>
  );
}

export function OutlineTree({ nodes, expandAllTrigger, collapseAllTrigger, onNavigate }) {
  return (
    <div className="outline-tree">
      {nodes.map((node, i) => (
        <OutlineNode key={node.id || i} node={node} expandAllTrigger={expandAllTrigger} collapseAllTrigger={collapseAllTrigger} onNavigate={onNavigate} />
      ))}
    </div>
  );
}
